import { type FC, useState } from 'react';
import { ModalActions, ModalContainer, ModalHeader } from '@/utils/modal';

interface ConfirmActivateTemplateProps {
  onClick: () => void | Promise<void>;
  closeModal: () => void;
}

const ConfirmActivateTemplate: FC<ConfirmActivateTemplateProps> = ({ onClick, closeModal }) => {
  const [busy, setBusy] = useState(false);

  const handleSubmit = async () => {
    setBusy(true);
    try {
      await onClick();
      closeModal();
    } finally {
      setBusy(false);
    }
  };

  return (
    <ModalContainer size="narrow" testKey="confirm-activate-template">
      <ModalHeader title="Set template as active?" closeModal={closeModal} className="pa3 bb b--moon-gray bg-white" />
      <div className="pa3 f6 dark-gray lh-copy">
        <p className="ma0">
          Activating this template will not regenerate sample names for existing sample plans. Stale sample names will
          be highlighted in each study and can be manually synchronised to the new template.
        </p>
      </div>
      <div className="pa3 bt b--moon-gray">
        <ModalActions
          submitBtnText="Set Active"
          onSubmit={handleSubmit}
          submitButtonProps={{ disabled: busy }}
          cancelBtnText="Cancel"
          onCancel={closeModal}
        />
      </div>
    </ModalContainer>
  );
};

export default ConfirmActivateTemplate;
